import { FieldState } from '../types/generic';

export const anprInitialState: FieldState = {
	sheetName: {
		value: '',
		errorText: new Set(),
		error: false,
		required: false,
		helperText: 'Name of the sheet in the file that contains the ANPR attribution data',
	},
	identifierColumn: {
		value: '',
		errorText: new Set(),
		error: false,
		required: false,
		helperText: 'Title of the column containing the Vehicle Registration Numbers (VRNs)',
	},
	attributedColumn: {
		value: '',
		errorText: new Set(),
		error: false,
		required: false,
		helperText: 'Title of the column containing the user names',
	},
};

export const cellebriteSheetInitialState: FieldState = {
	encoding: {
		value: '',
		errorText: new Set(),
		error: false,
		required: true,
		helperText: 'How the file was encoded. If unsure, select UTF-8',
	},
	hyperlink: {
		value: false,
		errorText: new Set(),
		error: false,
		helperText: ['Enables click-to-content processing of Cellebrite attachments', '[NOT CURRENTLY IMPLEMENTED]'],
	},
	detected: {
		value: false,
		errorText: new Set(),
		error: false,
		helperText: ['Attempt to do click-to-content processing on all data or only processed data', '[NOT CURRENTLY IMPLEMENTED]'],
	},
	ocr: {
		value: false,
		errorText: new Set(),
		error: false,
		helperText: ['Perform Optical Character Recognition on uploaded files', '[NOT CURRENTLY IMPLEMENTED]'],
	},
};

export const createOpInitialState: FieldState = {
	operationName: {
		value: '',
		errorText: new Set(),
		error: false,
		required: true,
		helperText: [
			'The name of the operation (5 characters minimum)',
			'Must only contain letters, numbers, or hyphens',
			'Cannot contain special characters such as @\';_".():',
			'Cannot begin or end with a hyphen',
		],
	},
	operationDescription: {
		value: '',
		errorText: new Set(),
		error: false,
		required: false,
		helperText: '(Optional) A description of the operation for later reference',
	},
};

export const keyphrasesInitialState: FieldState = {
	title: {
		value: '',
		errorText: new Set(),
		error: false,
		required: true,
		helperText: 'The name of the Keyphrases set, which will be used later to refer to it',
	},
	pipeline: {
		value: 'cellebrite-xml',
		errorText: new Set(),
		error: false,
		required: true,
		helperText:
			'Choose the pipeline that this keyphrases file will be used against (currently only the Cellebrite XML pipeline is implemented)',
	},
	useCase: {
		value: 'CSAE',
		errorText: new Set(),
		error: false,
		required: true,
		helperText: 'The use case of this Keyphrases set',
	},
	organisation: {
		value: '',
		errorText: new Set(),
		error: false,
		required: true,
		helperText: 'The organisation associated with this Keyphrases set',
	},
};
